import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5m4wqw135i: FaireBrandEntity = {
  token: "b_5m4wqw135i",
  type: "brand",
  name: "Panache Apparel Co.",
  avatarUrl: "https://cdn.faire.com/fastly/dfe52f12f90622252b0b5d6a5cc70c978d50f7e195d3bd89d11f657a1a1e8e75.jpeg",
  bannerUrl: "https://cdn.faire.com/fastly/3cb8b66f4b49ec3eb90000eb029c36cef4c5cc0632d4631a045c31894afe23b8.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/dfe52f12f90622252b0b5d6a5cc70c978d50f7e195d3bd89d11f657a1a1e8e75.jpeg",
  heroImageUrl: "https://cdn.faire.com/fastly/3cb8b66f4b49ec3eb90000eb029c36cef4c5cc0632d4631a045c31894afe23b8.jpeg",
  location: "Minnetonka, MN, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 1104,
  isTopShop: true,
  isInsider: true,
  description: "Panache Apparel is a woman-owned business that began in 2012. We are about living with style, having fun, promoting self-confidence, staying strong, keeping it casual, letting loose, being unwavering in our pursuits, living boldly and proudly, and promoting what we like.\n\nWe started on the basis of wanting to express how we think and feel without having to compromise on quality of fabric or aesthetic. We started by offering collections of trending, alternative accessories and slowly built out into a full apparel brand. Above all, our designs are steeped in quality and attention to detail.",
  meta: {
    source: "api",
    importedAt: "2026-10-28T20:56:46.183Z",
    importedBy: "entity-db-cli"
  }
};
